
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";

import MasterDesignationTable from "./MasterDesignationTable";

function MasterDesignationTableMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <MasterDesignationTable/>
            </BasicCard>
        </>
    )
}
export default MasterDesignationTableMain;